import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, CheckIcon, XIcon } from 'lucide-react';
import { Card } from './ui/Card';
export function OfferSection() {
  const whatYouGet = [{
    title: 'La Guía Maestra Cero Estrés 2-2-2',
    desc: '(PDF Step-by-Step)'
  }, {
    title: "El Cronograma del 'Domingo de Poder'",
    desc: 'Qué hacer minuto a minuto para terminar en 2 horas.'
  }, {
    title: 'La Matriz de las 2 Bolsas',
    desc: 'Tu lista de compras inteligente para eliminar el desperdicio.'
  }, {
    title: 'El Recetario de Salsas Mágicas',
    desc: '5 aderezos que transforman el sabor de cualquier plato.'
  }, {
    title: 'Planificador de Ensamblaje Semanal',
    desc: 'Para organizar tus cenas de lunes a viernes.'
  }];
  const whoIsFor = ['Mujeres trabajadoras que llegan a casa sin energía para pensar qué cocinar.', 'Mamás que quieren que sus hijos coman sano sin vivir pegadas a la estufa.', 'Personas que buscan ahorrar dinero optimizando sus compras de mercado.', 'Mujeres que sufren de fatiga de decisión y carga mental excesiva.'];
  const whoIsNotFor = ['Personas que buscan recetas gourmet de alta complejidad.', 'Quienes disfrutan pasar 3 horas diarias cocinando desde cero.', 'Quienes no están dispuestos a dedicar 2 horas un solo día para liberar el resto de su semana.'];
  return <section className="py-16 px-4 sm:px-6 bg-brand-bg" data-id="element-89">
      <div className="max-w-5xl mx-auto" data-id="element-90">
        <div className="text-center mb-12" data-id="element-91">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-92">
            Todo lo que obtienes hoy
          </h2>
          <div className="w-24 h-1 bg-brand-primary mx-auto rounded-full" data-id="element-93"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16" data-id="element-94">
          {/* What you get */}
          <Card className="border-brand-primary/30 shadow-lg relative overflow-hidden" data-id="element-95">
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-light opacity-50 rounded-bl-full -z-10" data-id="element-96"></div>
            <h3 className="text-2xl font-bold text-brand-text mb-6 flex items-center gap-2" data-id="element-97">
              <span data-id="element-98">🎁</span> Tu Paquete Incluye:
            </h3>
            <ul className="space-y-5" data-id="element-99">
              {whatYouGet.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-100">
                  <CheckCircle2Icon className="text-brand-accent flex-shrink-0 mt-1" size={24} data-id="element-101" />
                  <div data-id="element-102">
                    <span className="font-bold text-brand-text block" data-id="element-103">
                      {item.title}
                    </span>
                    <span className="text-brand-text/70 text-sm" data-id="element-104">
                      {item.desc}
                    </span>
                  </div>
                </motion.li>)}
            </ul>
          </Card>

          <div className="space-y-8" data-id="element-105">
            {/* Who is for */}
            <Card className="bg-white border-l-4 border-l-brand-accent" data-id="element-106">
              <h3 className="text-xl font-bold text-brand-text mb-4 flex items-center gap-2" data-id="element-107">
                <span data-id="element-108">✅</span> ESTO ES PARA TI SI:
              </h3>
              <ul className="space-y-3" data-id="element-109">
                {whoIsFor.map((item, index) => <li key={index} className="flex items-start gap-2 text-brand-text/80" data-id="element-110">
                    <CheckIcon className="text-brand-accent flex-shrink-0 mt-1" size={18} data-id="element-111" />
                    <span data-id="element-112">{item}</span>
                  </li>)}
              </ul>
            </Card>

            {/* Who is NOT for */}
            <Card className="bg-white border-l-4 border-l-red-400" data-id="element-113">
              <h3 className="text-xl font-bold text-brand-text mb-4 flex items-center gap-2" data-id="element-114">
                <span data-id="element-115">❌</span> ESTO NO ES PARA TI SI:
              </h3>
              <ul className="space-y-3" data-id="element-116">
                {whoIsNotFor.map((item, index) => <li key={index} className="flex items-start gap-2 text-brand-text/80" data-id="element-117">
                    <XIcon className="text-red-400 flex-shrink-0 mt-1" size={18} data-id="element-118" />
                    <span data-id="element-119">{item}</span>
                  </li>)}
              </ul>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}